export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-4 px-6">
      <div className="flex items-center justify-between text-sm text-gray-500">
        <p>
          &copy; {currentYear} CORTEX. All rights reserved.
        </p>
        <div className="flex items-center gap-4">
          <a
            href="#"
            className="hover:text-gray-700 transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="#"
            className="hover:text-gray-700 transition-colors"
          >
            Terms of Service
          </a>
          <a
            href="#"
            className="hover:text-gray-700 transition-colors"
          >
            Help
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
